import styled from 'styled-components';
import { Ico36 } from 'dc/Ico';
import { Typ70, Typ30 } from 'dc/Typ';
import ProgressCircle from 'dc/ProgressCircle';
import ToolTip01 from 'dc/ToolTip01';

export const Circle = styled(ProgressCircle)`
  border: 5px solid #fff;
  border-radius: 50%;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 180px;
`;

export const InnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Icon = styled(Ico36)``;

export const Value = styled(Typ70)``;

export const Unit = styled(Typ30)`
  margin-bottom: 16px;
`;

export const ToolTip = styled(ToolTip01)`
  div:nth-of-type(1) {
    width: 128px;
  }
  div:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
